define('LNRS/Track/TrackNavigation',["jquery", "Track/DataLayerManager"], function ($, dlmanager) {

    return function trackNavigation() {

        function trackFlyout($el) {
            var o = {
                site_events: { gnav_flyout_imp: "true" },
                event_name: "flyout impression",
                flyout_name: $el.children("a").first().text().trim(),
                flyout_class: $el.attr('class')
        };

            dlmanager.trackAnalytics(o);
        }

        // 7.9.1 Global Nav Flyout Impressions
        $(".score-megamenu-dropdown").on("show.bs.dropdown", function flyoutTimeout(ev) {
            trackFlyout($(ev.target));
        });

        // 7.9.2 Sticky Navigation Click
        // even though this uses bootstrap's scrollspy, we are not using the scrollspy event because if we are on item 1
        // and the user clicks item 4, bootstrap will fire that event for all items scrolled over along the way. But we only
        // need 1 event for the item that was clicked on.
        function trackStickyMenu(ev) {
            var o = {
                site_events: { sticky_nav_click: "true" },
                event_name: "sticky nav click",
                link_identifier: $(ev.target).text().replace(/\s\s+/g, " ")
            };

            dlmanager.trackAnalytics(o);
        }

        $(".score-sticky-anchor-menu .score-list-group-item a").each(function () {
            // need to use event capturing instead of bubbling to grab the click before bootstrap gets it
            // this will work for IE9+
            if (this.addEventListener) {
                this.addEventListener("click", trackStickyMenu, true);
            }
        });

        //track global nav header menu click event
        $('.score-header li.score-megamenu-basic-item a').each(function () {
            $(this).on('click', function (e) {
                var o = {
                    site_events: { gnav_click: "true" },
                    event_name: "gnav header click",
                    gnav_link_name: $(this).text().trim()
                };
                dlmanager.trackAnalytics(o);
            });
        });

        //track logo icon click event
        $('.navbar-header .navbar-brand').on('click', function (e) {
            var o = {
                site_events: { gnav_click: "true" },
                event_name: "Global Nav utility",
                gnav_link_name: "lnrs logo"
            };
            dlmanager.trackAnalytics(o);            
        });

        //track language selector event
        $('.btn-country-language-selector').on('click', function (e) {
            var o = {
                site_events: { gnav_flyout_imp: "true" },
                event_name: "Global Nav utility",
                flyout_name: "Region language"
            };
            dlmanager.trackAnalytics(o);            
        });

        //track product sign-in click event
        $('.btn-product-sign-in').on('click', function (e) {
            var o = {
                site_events: { gnav_flyout_imp: "true" },
                event_name: "Global Nav utility",
                flyout_name: "Product sign in"
            };
            dlmanager.trackAnalytics(o);
        });

        //track sub menu header main menu click event
        $('.sub-nav-visible .score-button-group .score-button').each(function () {
            $(this).on('click', function (e) {
                var o = {
                    site_events: { subnav_click: "true" },
                    event_name: "subnav header click",
                    subnav_link_name: $(this).text().trim()
                };
                dlmanager.trackAnalytics(o);
            });
        });

        //For SubNav Menu Items with dropdown items click
        $('.sub-nav-visible .score-button-menu button').each(function () {
            $(this).on('click', function (e) {
                var dropdownName = $(this)
                    .contents()
                    .get()
                    .map(function (n) { return n.nodeType === 3 ? n.textContent.trim() : ''; })
                    .join('');
                
                var o = {
                    site_events: { subnav_dropdown_imp: "true" },
                    event_name: "dropdown impression",
                    dropdown_name: dropdownName
                };
                dlmanager.trackAnalytics(o);
            });
        });

        //For subnav menu Items with dropdown link clicks
        $('.sub-nav-visible li.score-button-menu-item a').each(function () {
            $(this).on('click', function (e) {
                var o = {
                    site_events: { subnav_click: "true" },
                    event_name: "subnav header click",
                    subnav_link_name: $(this).text().trim()
                };
                dlmanager.trackAnalytics(o);
            });
        });
       
    };
});
